export type FeatureSwitches = {
  userSwitches: string[];
  schoolSwitches: string[];
  classroomSwitches: string[];
  communitySwitches: string[];
  classOwnerSwitches: string[];
};

export const SCHOOL_FEATURE_SWITCHES = {
  // Block Building Features
  MONSTERVERSE_ENABLE_ALL_BLOCKS: "monsterverseEnableAllBlocks",

  // Renderering tech
  MONSTERVERSE_USE_TERRAIN_MULTIDRAW: "monsterverseUseTerrainMultiDraw",
  MONSTERVERSE_USE_UPSCALE_UI: "monsterverseUseUpscaleUIv3",
  MONSTERVERSE_USE_AO_MEMORY_MANAGER: "monsterverseUseAOMemoryManager",
  MONSTERVERSE_USE_CACHED_MESH2: "monsterverseUseCachedMesh2",

  // Ecs
  MONSTERVERSE_ECS_UIDS: "monsterverseEcsUids",
};

export const USER_FEATURE_SWITCHES = {
  MONSTERVERSE_USE_BASIS_VT: "monsterverseUseBasisVT",
  MONSTERVERSE_USE_PER_PIXEL_LIGHTING: "monsterverseUsePerPixelLighting",

  MONSTERVERSE_USE_SSAO: "monsterverseUseSSAO",
  MONSTERVERSE_REMOVE_PRELOADED_ASSETS: "monsterverseRemovePreloadedAssets",
  MONSTERVERSE_SKIP_HTTP_ASSET_CACHE: "monsterverseSkipHttpAssetCache",
  MONSTERVERSE_NO_PRELOAD_SOUNDS: "monsterverseNoPreloadSounds",

  MONSTERVERSE_TERRAIN_EXPERIMENT: "monsterverseTerrainExperiment2",

  MONSTERVERSE_RATE_AGNOSTIC_JUMP: "monsterverseRateAgnosticJump",

  // Debugging and diagnostics
  MONSTERVERSE_NETWORK_METRICS_TRACKING: "monsterverseNetworkMetricsTracking",

  /** NOTE: Below, we also have a community version of the FTUE FS which is only used for playtesting purposes */
  MONSTERVERSE_FTUE: "monsterverseFTUE",

  MONSTERVERSE_CUSTOMIZER_NEW_SAVE_BUTTONS_V3: "monsterverseCustomizerNewSaveButtonsV3",

  MONSTERVERSE_DEV_USER: "monsterverseDevUser",
};

export const CLASSROOM_FEATURE_SWITCHES = {
  MONSTERVERSE_ZOMBIE_TAG_CLASS: "monsterverseZombieTagClass",
  MONSTERVERSE_CTC_CLASS: "monsterverseCTCClass",
  MONSTERVERSE_BLAST_SPLASH_CLASS: "monsterverseBlastSplashClass",
  MONSTERVERSE_PAINT_PARTY_CLASS: "monsterversePaintPlaygroundClass",
  MONSTERVERSE_GRADUATION_2025_CLASS: "monsterverseGraduation2025Class", // This is checked in the FS component in the scene

  // Users FS is not actually used for rollout, just for gathering user level exposures
  MONSTERVERSE_ZOMBIE_TAG_CLASS_USERS: "monsterverseZombieTagClass_users",
  MONSTERVERSE_CTC_CLASS_USERS: "monsterverseCTCClass_users",
  MONSTERVERSE_BLAST_SPLASH_CLASS_USERS: "monsterverseBlastSplashClass_users",
  MONSTERVERSE_PAINT_PARTY_CLASS_USERS: "monsterversePaintPlaygroundClass_users",

  MONSTERVERSE_DEV_CLASS: "monsterverseDevClass",
};

export const COMMUNITY_FEATURE_SWITCHES = {
  MONSTERVERSE_HOME_UNLIMITED_BLOCKS: "monsterverseHomeUnlimitedBlocks",
  MONSTERVERSE_GUEST_VIP_ISLANDS: "monsterverseGuestVipIslands",

  MONSTERVERSE_ROLEPLAY_CORNER: "monsterverseRoleplayCorner",

  MV_PLAY_ACTIVITY_PLAYTEST: "mvPlayActivityPlaytest",

  MONSTERVERSE_DOLPHIN_POWERUP: "monsterverseDolphinPowerup",

  MONSTERVERSE_MATCHMAKING_TEST: "monsterverseMatchmakingTest",

  MONSTERVERSE_PLAYGROUNDS: "monsterversePlaygrounds",

  MONSTERVERSE_SCREEN_UI: "monsterverseScreenUI",

  /** We have a community version of the FTUE FS which is only used for playtesting purposes */
  MONSTERVERSE_FTUE_C: "monsterverseFTUEC",

  MONSTERVERSE_DEV_COMMUNITY: "monsterverseDevCommunity",
};

// Used to support a Mentor Beta program that opts in features based on the owner of a class.
export const CLASS_OWNER_FEATURE_SWITCHES = {};

export const FEATURE_SWITCHES = {
  ...USER_FEATURE_SWITCHES,
  ...SCHOOL_FEATURE_SWITCHES,
  ...CLASSROOM_FEATURE_SWITCHES,
  ...COMMUNITY_FEATURE_SWITCHES,
  ...CLASS_OWNER_FEATURE_SWITCHES,
};

export const FEATURE_SWITCHES_TO_CHECK: FeatureSwitches = {
  userSwitches: Object.values<string>(USER_FEATURE_SWITCHES),
  schoolSwitches: Object.values<string>(SCHOOL_FEATURE_SWITCHES),
  classroomSwitches: Object.values<string>(CLASSROOM_FEATURE_SWITCHES),
  communitySwitches: Object.values<string>(COMMUNITY_FEATURE_SWITCHES),
  classOwnerSwitches: Object.values<string>(CLASS_OWNER_FEATURE_SWITCHES),
};

//Feature switches shown in the editor's Visibility menu
export const EDITOR_FEATURE_SWITCHES = ["spookySeason", "fallSeason", "winterSeason"];
